webpackJsonp([0],{

/***/ 589:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Abe_Clark_thumbnail_headshot.b1f35f31.jpeg";

/***/ },

/***/ 535:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(28);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLinkedin = function FaLinkedin(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10.8 13.9v22.2h-7.4v-22.1h7.4z m0.5-6.8q0 1.7-1.2 2.7t-3 1.1h0q-1.9 0-3-1.1t-1.1-2.7q0-1.6 1.2-2.7t3-1.1 2.9 1.1 1.2 2.7z m26 16.3v12.7h-7.4v-11.9q0-2.3-0.9-3.6t-2.8-1.4q-1.4 0-2.3 0.8t-1.5 1.9q-0.2 0.7-0.2 1.8v12.4h-7.3q0-8.9 0-14.5t0-6.6l0-1h7.3v3.2h-0.1q0.5-0.7 1-1.3t1.2-1.1 2-1 2.5-0.4q3.8 0 6.2 2.6t2.3 7.4z' })
	        )
	    );
	};
	
	exports.default = FaLinkedin;
	module.exports = exports['default'];

/***/ },

/***/ 84:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(129);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRouter = __webpack_require__(57);
	
	var _get = __webpack_require__(67);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _typography = __webpack_require__(10);
	
	var _SiteMargin = __webpack_require__(30);
	
	var _SiteMargin2 = _interopRequireDefault(_SiteMargin);
	
	var _authors = __webpack_require__(265);
	
	var _Header = __webpack_require__(83);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaLinkedin = __webpack_require__(535);
	// import '../css/zenburn.css'
	
	var Detail = function (_React$Component) {
	  _inherits(Detail, _React$Component);
	
	  function Detail() {
	    _classCallCheck(this, Detail);
	
	    return _possibleConstructorReturn(this, (Detail.__proto__ || Object.getPrototypeOf(Detail)).apply(this, arguments));
	  }
	
	  _createClass(Detail, [{
	    key: 'render',
	    value: function render() {
	      var blogPost = this.props.data.markdown;
	      var metadata = (0, _get2.default)(this.props, 'data.site.siteMetadata');
	      var author = _authors.authors[blogPost.frontmatter.author];
	      return Glamor.createElement(
	        'div',
	        null,
	        Glamor.createElement(_reactHelmet2.default, {
	          title: blogPost.frontmatter.title + ' | ' + metadata.title,
	          meta: [{ name: 'og:type', content: 'article' }, { name: 'og:image', content: blogPost.photoURL || metadata.photoURL || '' }, { name: 'og:url', content: 'krasadev.com' }, { name: 'og:description', content: metadata.description }, { name: 'fb:app_id', content: metadata.fbAppID }]
	        }),
	        Glamor.createElement(_Header2.default, null),
	        Glamor.createElement(
	          'h1',
	          {
	            style: { textAlign: 'center', margin: 0 }
	          },
	          Glamor.createElement(
	            _SiteMargin2.default,
	            { style: { padding: (0, _typography.rhythm)(2) + ' ' + (0, _typography.rhythm)(1) } },
	            blogPost.frontmatter.title
	          )
	        ),
	        Glamor.createElement(
	          _SiteMargin2.default,
	          { style: { padding: '0 ' + (0, _typography.rhythm)(1 / 2) } },
	          Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: blogPost.bodyHTML } })
	        ),
	        Glamor.createElement(
	          'div',
	          null,
	          Glamor.createElement(
	            _SiteMargin2.default,
	            { style: { padding: (0, _typography.rhythm)(1) } },
	            Glamor.createElement(
	              'div',
	              {
	                style: {
	                  position: 'relative',
	                  height: (0, _typography.rhythm)(2)
	                }
	              },
	              Glamor.createElement('img', {
	                src: author.thumbnail,
	                style: {
	                  height: (0, _typography.rhythm)(2),
	                  borderRadius: '100%',
	                  position: 'absolute',
	                  top: 0,
	                  left: 0
	                }
	              }),
	              Glamor.createElement(
	                'div',
	                {
	                  style: {
	                    position: 'absolute',
	                    left: (0, _typography.rhythm)(2),
	                    paddingLeft: (0, _typography.rhythm)(1 / 2),
	                    top: 0
	                  }
	                },
	                Glamor.createElement(
	                  'a',
	                  { href: author.linkedIn },
	                  author.firstName,
	                  ' ',
	                  author.lastName
	                ),
	                Glamor.createElement('br', null),
	                author.city,
	                ',',
	                ' ',
	                author.state
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Detail;
	}(_react2.default.Component);
	
	var pageQuery = exports.pageQuery = '\nquery Article($path: String!) {\n  site {\n    siteMetadata {\n      title\n      photoURL\n      fbAppID\n      description\n    }\n  }\n  markdown(path: $path) {\n    bodyHTML\n    frontmatter {\n        title\n        author\n        photoURL\n    }\n  }\n}\n';
	
	exports.default = Detail;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },

/***/ 265:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authors = undefined;
	
	var _Abe_Clark_thumbnail_headshot = __webpack_require__(589);
	
	var _Abe_Clark_thumbnail_headshot2 = _interopRequireDefault(_Abe_Clark_thumbnail_headshot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authors = exports.authors = {
	  abe: {
	    firstName: 'Abe',
	    lastName: 'Clark',
	    city: 'San Francisco',
	    state: 'CA',
	    linkedIn: 'https://www.linkedin.com/in/abrahamclark',
	    thumbnail: _Abe_Clark_thumbnail_headshot2.default
	  },
	  lindsay: {
	    firstName: 'Lindsay',
	    lastName: 'Clark',
	    city: 'San Francisco',
	    state: 'CA',
	    linkedIn: 'https://www.linkedin.com/in/lindsay-clark-413082117',
	    thumbnail: null
	  }
	};

/***/ }

});


// WEBPACK FOOTER //
// page-component---page-templates-blog-detail-js-e520bf3e2446249a0d83.js